import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const SAVED_REPORTS_TABLE_STATE_STORAGE_KEY = "userSavedReportsList";

export const SAVED_REPORTS_LIST_COLUMN_IDS = {
    NAME: "name",
    DESCRIPTION: "description",
    TYPE: "type",
    ACCESS_RIGHT: "accessRight",
} as const;

export const savedReportsListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: SAVED_REPORTS_LIST_COLUMN_IDS.NAME, desc: false }],
    };

export const savedReportsListColumnFiltersCodecMap = {
    [SAVED_REPORTS_LIST_COLUMN_IDS.NAME]: withModeCodec(encodedArrayCodec),
    [SAVED_REPORTS_LIST_COLUMN_IDS.TYPE]: withModeCodec(encodedArrayCodec),
    [SAVED_REPORTS_LIST_COLUMN_IDS.ACCESS_RIGHT]:
        withModeCodec(encodedArrayCodec),
};
